@if (this.errors.length > 0) {
    <mat-card
        id="validation-summary"
        class="alert-error"
        animate.enter="grow-in"
        animate.leave="grow-out"
        (click)="focusCard($event)">
        <mat-card-header class="d-flex flex-column align-items-center">
            <mat-card-title>
                <mat-icon color="warn" matTooltip="Missing Required Information" class="mat-48">warning</mat-icon>
                {{ name }}
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <ul>
                @for (e of errors; track $index) {
                    <li class="validation-error text-center" (click)="focusError($event, e)">
                        {{ e.field }} {{ e.error }}
                    </li>
                }
            </ul>
        </mat-card-content>
    </mat-card>
}
